
import * as angular from "angular";

import "./barChart.scss";

export interface IBarChartBar {
    label: string;
    count: number;
    height: number;
    className?: string
    bgColor?: string;
}

interface IComponentBindings {
    bars: IBarChartBar[];
    useBarThresholds: boolean;
}

class ComponentController implements angular.IComponentController, IComponentBindings {
    bars: IBarChartBar[];
    useBarThresholds: boolean;

    maxValue = 0;

    static $inject = [];

    constructor() {
    }

    $onInit(): void {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        this.updateMaxValue();
        this.updateBarHeights();
    }

    // ---

    private updateMaxValue() {

        this.maxValue = 0;
        this.bars.forEach(bar => {
            this.maxValue = Math.max(this.maxValue, bar.count);
        });
    }

    private updateBarHeights() {

        this.bars.forEach(bar => {
            bar.height = bar.count / this.maxValue * 100;

            if (this.useBarThresholds) {
                if (bar.height > 75) { bar.className = "red-bg"; }
                else if (bar.height > 50) { bar.className = "orange-bg"; }
            }
        });
    }
}

export class BarChartComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    transclude: boolean | { [index: string]: string; };

    constructor() {
        this.bindings = {
            bars: "<",
            useBarThresholds: "<"
        };

        this.transclude = true;
        this.controller = ComponentController;
        this.template = require("./barChart.html");
    }
}
